//debugger;
function assert(guard, message) {
  if (!guard) {
    throw new Error(message || 'assert failed');
  }
  return guard;
}

function Nil(x) {
  assert(Nil.is(x), `${x} is not a Nil`);
  return x;
}

Nil.is = function (x) {
  return x === null || x === void 0;
};

Nil.of = Nil;

function Str(x) {
  assert(Str.is(x), x + " is not a Str");
  return x;
}

Str.is = function(x) {
  return (typeof x === 'string') ||
    (x && x.constructor === String);
};

Str.of = Str;

function Num(x) {
  assert(Num.is(x), x + " is not a Num");
  return x;
}

Num.is = function(x) {
  return ((typeof x === 'number') || (x && x.constructor === Number)) &&
    isFinite(x) &&
    !isNaN(x);
};

Num.of = Num;

function Bool(x) {
  assert(Bool.is(x), x + " is not a Bool");
  return x;
}

Bool.is = function(x) {
  return x === true ||
    x === false;
};

Bool.of = Bool;

function Arr(x) {
  assert(Arr.is(x), x + " is not a Arr");
  return x;
}

Arr.is = function(x) {
  return x instanceof Array;
};

Arr.of = Arr;

Arr.of_length = function(n) {
  var arr = [];
  for (var i = 0; i < n; i++) {
    arr[i] = null;
  }
  return arr;
};

function Obj(x) {
  assert(Obj.is(x), x + " is not a Obj");
  return x;
}

Obj.is = function(x) {
  return x &&
    x instanceof Object &&
    !Arr.is(x);
};

Obj.of = Obj;

function Func(x) {
  assert(Func.is(x), x + " is not a Func");
  return x;
}

Func.is = function(x) {
  return typeof x === 'function';
};

Func.of = Func;

function Err(x) {
  assert(Err.is(x), x + " is not a Err");
  return x;
}

Err.is = function(x) {
  return x instanceof Error;
};

Err.of = function(x) {
  assert(Obj.is(x));
  return mixin(new Error(), x);
};

function List(type) {
  assert(Func.is(type));

  function List(x) {
    assert(List.is(x));
    return x;
  }

  List.is = function(x) {
    return Arr.is(x) && all(x, function(e) {
      return type.is(e);
    });
  };

  List.of = function(xs) {
    assert(Arr.is(xs));
    return List(xs.map(type.of));
  };

  return List;
}

function Enum(elements) {
  assert(List(Str).is(elements));

  function Enum(x) {
    assert(Enum.is(x));
    return x;
  }

  Enum.elements = elements;
  Enum.index = to_obj(elements);

  Enum.is = function(x) {
    return Str.is(x) &&
      (x in Enum.index);
  };

  Enum.of = Enum;

  return Enum;

}

function Subtype(type, p) {
  assert(Func.is(type));
  assert(Func.is(p));

  function Subtype(x) { // eslint-disable-line no-unused-vars
    assert(Subtype.is(x));
    return x;
  }

  Subtype.is = function(x) {
    return type.is(x) &&
      p(x);
  };

  Subtype.of = function(x) {
    return type.of(x);
  };

  return Subtype;
}

function Union(types) {
  assert(List(Func).is(types));

  function Union(x) {
    assert(Union.is(x));
    return x;
  }

  Union.types = types;

  Union.is = function(x) {
    return any(Union.types, function(type) {
      return type.is(x);
    });
  };

  // in generale non è possibile stabilire come fare
  // la funzione di deserializzazione di una unione
  // occorre definirla di volta in volta
  Union.of = function() {
    assert(false, 'you must provide a custom of()');
  };

  return Union;

}

function Maybe(type) {

  var Maybe = function(x) {
    assert(Maybe.is(x));
    return x;
  };

  Maybe.is = function(x) {
    return (Nil.is(x)) ||
      type.is(x);
  };

  Maybe.of = function(obj) {
    assert(Func.is(type.of));
    return Nil.is(obj) ?
      null :
      type.of(obj);
  };

  return Maybe;
}

function Tuple(types) {
  assert(List(Func).is(types));

  function Tuple(x) {
    assert(Tuple.is(x));
    return x;
  }

  Tuple.is = function(x) {
    return Arr.is(x) &&
      (x.length === types.length) &&
      all(x, function(e, i) {
        return types[i].is(e);
      });
  };

  Tuple.of = function(xs) {
    return Tuple(xs.map(function(x, i) {
      return types[i].of(x);
    }));
  };

  return Tuple;

}

function Dict(K, V) {

  var Dict = function(x) {
    assert(Dict.is(x));
    return x;
  };

  Dict.is = function(x) {
    if (!Obj.is(x)) {
      return false;
    }
    for (var k in x) {
      if (x.hasOwnProperty(k)) {
        if (!K.is(k)) {
          return false;
        }
        if (!V.is(x[k])) {
          return false;
        }
      }
    }
    return true;
  };

  Dict.of = function(x) {
    assert(Obj.is(x));

    var ret = {};
    for (var k in x) {
      if (x.hasOwnProperty(k)) {
        ret[K.of(k)] = V.of(x[k]);
      }
    }
    return ret;
  };

  return Dict;

}

// duck typing
function Interface(descriptor) {
  assert(Obj.is(descriptor));

  function Interface() {}

  Interface.is = function(x) {
    if (!Obj.is(x)) {
      return false;
    }
    for (var k in descriptor) {
      if (!descriptor[k].is(x[k])) {
        return false;
      }
    }
    return true;
  };

  Interface.of = function(x) {
    assert(Interface.is(x));
    return x;
  };

  return Interface;
}

// # Definizioni dei tipi più comuni

// un intero
var Int = Subtype(Num, is_integer);

// un intero non negativo
var Natural = Subtype(Int, is_not_negative);

// un intero positivo
var Positive = Subtype(Int, is_positive);

// il prezzo di un oggetto
var Amount = Subtype(Num, is_not_negative);

// una data in formato Unix
var Datetime = Int;

// un identificativo univoco
var UUID = Subtype(Str, is_uuid);

// un URL assoluto
var URL = Subtype(Str, is_url);

// una email
var Email = Subtype(Str, is_email);

// una valuta supportata dalla piattaform
var Currency = Enum('EUR GBP USD ZAR BRL'.split(' '));

// una lingua supportata dalla piattaform
var Language = Enum(['it', 'en', 'fr', 'es', 'de', 'pt']);

// un paese supportato dalla piattaform
var Country = Enum(['AT', 'AU', 'BE', 'BR', 'CA', 'CH', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'IE', 'IT', 'LU', 'MC', 'NL', 'NO', 'PL', 'PT', 'SE', 'TR', 'US', 'ZA']);

// un colore css
var Color = Subtype(Str, is_color);

// un locale in formato codice iso, es: it_IT, fr_fr, en_GB
var Locale_Iso = Subtype(Str, function(x) {
  var parts = x.split('_');
  return Language.is(parts[0]) && Country.is(parts[1]);
});

// un valore primitivo valido in JSON
var JSON_Value = Union([Str, Num, Bool]);
JSON_Value.of = function(x) {
  return JSON_Value(x);
};

// nome valido per un attributo html o per uno stile css
var Attr_Name = Subtype(Str, function(x) {
  return (/^[$a-z_][$0-9a-z_-]*$/i).test(x);
});

// valore valido per un attributo html o per uno stile css
var Attr_Value = Subtype(Union([JSON_Value, List(Str), Obj]), function(x) {
  return !(Nil.is(x) || x === false || (Obj.is(x) && Obj.is_empty(x)));
});

// parti di una data
var Year = Int;
var Month = Subtype(Natural, function(x) {
  return x >= 1 && x <= 12;
});
var Day = Subtype(Natural, function(x) {
  return x >= 1 && x <= 31;
});
var Hour = Subtype(Natural, function(x) {
  return x >= 0 && x <= 23;
});
var Minute = Subtype(Natural, function(x) {
  return x >= 0 && x <= 59;
});

// rappresentazione di una data come tupla delle sue parti

function days_per_month(yyyy) {
  return function(MM) {
    return {
      0: 31,
      1: yyyy % 4 === 0 ? 29 : 28, // handle leap year
      2: 31,
      3: 30,
      4: 31,
      5: 30,
      6: 31,
      7: 31,
      8: 30,
      9: 31,
      10: 30,
      11: 31
    }
    [MM - 1];
  };
}

var Short_Date = Subtype(Tuple([Year, Month, Day]), function(x) {
  return x[2] <= days_per_month(x[0])(x[1]);
});
var Accurate_Date = Subtype(Tuple([Year, Month, Day, Hour, Minute]), function(x) {
  return x[2] <= days_per_month(x[0])(x[1]);
});

var Str_Option = Tuple([Str, Str]);

// formato markdown
function Markdown(value) {
  assert(Str.is(value));
  this.value = value;
  return freeze(this);
}

Markdown.is = function(x) {
  return x instanceof Markdown;
};

Markdown.of = function(x) {
  return new Markdown(x);
};

Markdown.prototype.toJSON = function() {
  return this.value;
};

Markdown.prototype.toString = function() {
  return micromd(this.value);
};

// rappresenta sia un tipo di internazionalizzazione sia un tipo di localizzazione
function Locale(language, country) {
  assert(Language.is(language));
  assert(Country.is(country));
  this.language = language;
  this.country = country;
  return freeze(this);
}

Locale.is = function(x) {
  return x instanceof Locale;
};

Locale.of = function(iso) {
  assert(Locale_Iso.is(iso));
  var a = iso.split('_');
  return new Locale(a[0], a[1]);
};

Locale.prototype.toJSON = Locale.prototype.toString = function() {
  return this.language + '_' + this.country;
};

// il bundle di localizzazione serve per formattare numeri, date e valute
Locale.prototype.locale_bundle = function() {
  var bundle = window.require('io/' + this);
  assert(Obj.is(bundle));
  return bundle;
};

// il bundle di internazionalizzazione
// Serve per tradurre le regole di validazione di una form, tradurre i paesi
// e le lingue
Locale.prototype.language_bundle = function() {
  var bundle = window.require('io/' + this.language);
  assert(Obj.is(bundle));
  return bundle;
};

Locale.prototype.display_country = function(country) {
  assert(Country.is(country));
  var bundle = this.language_bundle();
  assert(Obj.is(bundle));
  return bundle.country[country];
};

Locale.prototype.display_language = function(language) {
  assert(Language.is(language));
  return this.language_bundle().language[language];
};

Locale.prototype.to_number_format = function(opt_digits) {
  assert(Maybe(Natural).is(opt_digits));
  var bundle = this.locale_bundle().number;
  return new Number_Format(
    bundle.decimal_symbol,
    Nil.is(opt_digits) ? bundle.digits : opt_digits,
    bundle.grouping_symbol,
    bundle.infinity,
    bundle.negative_suffix,
    bundle.positive_suffix
  );
};

Locale.prototype.format_date = function(millis, is_accurate) {
  var bundle = this.locale_bundle().date;
  var pattern = is_accurate ? bundle.accurate : bundle['short'];
  return Datetime.format(millis, pattern);
};

Locale.prototype.format_number = function(n, digits) {
  return Num.format(n, this.to_number_format(digits));
};

Locale.prototype.format_integer = function(n) {
  return this.format_number(n, 0);
};

Locale.prototype.parse_number = function(n) {
  return this.to_number_format().parse_number(n);
};

// # Tool di sviluppo

// log sulla console x-browser
function log(s) {
  if (typeof console !== 'undefined') {
    console.log(s); // eslint-disable-line no-console
  }
}

// genera un uuid (RFC-4122)
function uuid() {
  var chars = '0123456789abcdef'.split(''),
    id = [],
    rnd = Math.random,
    r;

  id[8] = id[13] = id[18] = id[23] = '-';
  id[14] = '4';
  for (var i = 0; i < 36; i++) {
    if (!id[i]) {
      r = 0 | rnd() * 16;
      id[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r & 0xf];
    }
  }
  return id.join('');
}

function prop(name) {
  return function(x) {
    return x[name];
  };
}

// aggiunge i campi propri di y a x
function mixin(x, y) {
  for (var k in y) {
    if (y.hasOwnProperty(k)) {
      x[k] = y[k];
    }
  }
  return x;
}

// mixin() senza side effects
function merge(x, y) {
  return mixin(mixin({}, x), y);
}

// copia di x passando dalla sua rappresentazione json
function copy(x) {
  return JSON.parse(JSON.stringify(x));
}

// ## Funzioni sugli Array

function all(xs, p) {
  assert(Arr.is(xs));
  assert(Func.is(p));
  for (var i = 0, len = xs.length; i < len; i++) {
    if (!p(xs[i], i)) {
      return false;
    }
  }
  return true;
}

function any(xs, p) {
  // non faccio asserts, li fa già all()
  return !all(xs, function(x, i) {
    return !p(x, i);
  });
}

// utility: per ordinare una lista di oggetti per il campo name
function by() {
  var fields = arguments;
  return function(a, b) {
    for (var i = 0, len = fields.length; i < len; i = i + 2) {
      var name = fields[i];
      var is_desc = fields[i + 1];
      if (is_desc) {
        if (a[name] > b[name]) {
          return -1;
        }
        else if (a[name] < b[name]) {
          return 1;
        }
      }
      else {
        if (a[name] < b[name]) {
          return -1;
        }
        else if (a[name] > b[name]) {
          return 1;
        }
      }
    }
    return 0;
  };
}

/*
function by(name, is_desc) {
    var asc = function (a, b) {
        return a[name] < b[name] ? -1 : a[name] === b[name] ? 0 : 1;
    };
    var desc = function (a, b) {
        return a[name] > b[name] ? -1 : a[name] === b[name] ? 0 : 1;
    };
    return is_desc ? desc : asc;
}
*/

// utility per ordinare le option di una select
function by_description(a, b) {
  return a[1] < b[1] ? -1 : a[1] === b[1] ? 0 : 1;
}

// converte un array in un oggetto
//
//     to_obj(['a', 'b']) -> {a: 0, b: 1}
function to_obj(xs, f) {
  assert(Arr.is(xs));

  f = f || function(ret, x, i) {
    ret[x] = i;
  };

  var ret = {};
  for (var i = 0, len = xs.length; i < len; i++) {
    f(ret, xs[i], i);
  }
  return ret;
}

// trasforma un oggetto in un oggetto mantenendo le stesse chiavi
function map_obj(obj, f) {
  var result = {};
  for (var k in obj) {
    result[k] = f(obj[k], k);
  }
  return result;
}

// converte un oggetto in un array
function to_arr(obj, f) {
  assert(Obj.is(obj));

  f = f || function(v, k) {
    return [k, v];
  };

  var xs = [];
  for (var k in obj) {
    xs.push(f(obj[k], k));
  }
  return xs;
}

// l'indice del primo elemento di xs che soddisfa il predicato p
// se p è una stringa viene interpretato come id
function index_of(xs, p) {
  assert(Arr.is(xs));
  assert(Union([Func, Str]).is(p));

  var f = Func.is(p) ?
    p :
    function(x) {
      return x.id === p;
    };

  for (var i = 0, len = xs.length; i < len; i++) {
    if (f(xs[i])) {
      return i;
    }
  }
  return -1;
}

// il primo elemento di xs che soddisfa il predicato p
// altrimenti null.
// se p è una stringa viene interpretato come id
function find(xs, p) {
  var i = index_of(xs, p);
  return i === -1 ? null : xs[i];
}

// un nuovo array contenente gli elementi di xs tranne quello
// che stava in posizione at
function remove(xs, at) {
  assert(at >= 0 && at <= xs.length - 1);
  var ys = xs.slice();
  ys.splice(at, 1);
  return ys;
}

// un array in cui l'elemento di xs di indice from si ritrova
// all'indice to
//     move([1, 2, 3, 4, 5], 3, 1) => [1, 4, 2, 3, 5]
function move(xs, from, to) {
  assert(from >= 0 && from <= xs.length - 1);
  assert(to >= 0 && to <= xs.length - 1);
  var ys = xs.slice();
  var el = ys.splice(from, 1)[0];
  ys.splice(to, 0, el);
  return ys;
}

// ## Funzioni caratteristiche

function is_positive(n) {
  return n > 0;
}

function is_not_negative(n) {
  return n >= 0;
}

function is_integer(n) {
  return n === parseInt(n, 10);
}

var is_uuid_regexp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function is_uuid(s) {
  return is_uuid_regexp.test(s);
}

// true se l'email è formalmente valida
var is_email_regexp = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;

function is_email(s) {
  return is_email_regexp.test(s);
}

// true se s contiene solo cifre
var is_digits_regexp = /^\d*$/;

function is_digits(s) {
  return is_digits_regexp.test(s);
}

// true se il numero è pari
function is_even(n) {
  return n % 2 === 0;
}

// true se s è la rappresentazione in stringa di un numero JavaScript
var is_numeric_regexp = /^-{0,1}\d*\.{0,1}\d+$/;

function is_numeric(s) {
  return is_numeric_regexp.test(s);
}

// true se è un url assoluto formalmente valido
var is_url_regexp = /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

function is_url(s) {
  return is_url_regexp.test(s);
}

// true se è un url https assoluto formalmente valido
function is_https_url(s) {
  return is_url(s) && starts_with(s, 'https');
}

// true se s comincia con start
function starts_with(s, start) {
  return s.indexOf(start) === 0;
}

// true se s è un colore css
var is_color_regexp = /^#([a-f0-9]{6}|[a-f0-9]{3})$/i;

function is_color(s) {
  return is_color_regexp.test(s);
}

// ## Funzioni sugli Obj

// true se x non ha chiavi proprie
Obj.is_empty = function(x) {
  assert(Obj.is(x));
  for (var k in x) {
    if (x.hasOwnProperty(k)) {
      return false;
    }
  }
  return true;
};

// array delle chiavi
function keys(obj) {
  assert(Obj.is(obj));
  var ret = [];
  for (var k in obj) {
    ret.push(k);
  }
  return ret;
}

// array dei valori
function values(obj) {
  assert(Obj.is(obj));
  var ret = [];
  for (var k in obj) {
    ret.push(obj[k]);
  }
  return ret;
}

// rende immutabile un oggetto per i browser che lo supportano
// devo controllare che x sia un oggetto perchè Object.freeze
// è definita solo sugli oggetti e lancerebbe un errore
function freeze(x) {
  return Obj.is(x) && Object.freeze ?
    Object.freeze(x) :
    x;
}

// converte un oggetto in una querystring;
// non serializzo null e undefined
//
//     to_querystring({a: 1, b: 2}) -> a=1&b=2
function to_querystring(obj) {
  assert(Obj.is(obj));

  var url = [];
  for (var k in obj) {
    if (obj.hasOwnProperty(k) && !Nil.is(obj[k])) {
      url.push(encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]));
    }
  }
  return url.join('&');
}

// parse_querystring('a=1&b=2') -> {a: 1, b: 2}
function parse_querystring(qs) {
  assert(Str.is(qs));
  var params = {};
  if (qs) {
    // se nella querystring compare ? lo elimino
    var pairs = qs.replace(/\?/, '').split('&');
    pairs.forEach(function(pair) {
      var arr = pair.split('=');
      params[decodeURIComponent(arr[0])] = decodeURIComponent(arr[1]);
    });
  }
  return params;
}

// appende una querystring ad un url esistente
// il parametro querystring può essere una stringa o una mappa di parametri
function to_url(url, querystring) {
  assert(Str.is(url));
  assert(Maybe(Union([Str, Obj])).is(querystring));

  // mi assicuro che querystring sia una stringa
  // e se non è vuota gestisco la presenza del ? nell'url
  // prima di appenderla

  querystring = Obj.is(querystring) ?
    to_querystring(querystring) :
    querystring || '';

  if (querystring) {
    // è già presente il ?
    if (url.indexOf('?') !== -1) {
      url += '&' + querystring;
    }
    else {
      // è presente un hash?
      var hash_index = url.indexOf('#');
      if (hash_index !== -1) {
        var hash = url.substring(hash_index);
        url = url.substring(0, hash_index) + '?' + querystring + hash;
      }
      else {
        url += '?' + querystring;
      }
    }
  }

  return url;
}

// elimina i null e gli undefined dagli array e dagli oggetti in modo ricorsivo
// serve a rendere più piccoli i JSON serializzati
function compact(x) {
  var y = x;
  if (Obj.is(x)) {
    y = {};
    for (var k in x) {
      if (x.hasOwnProperty(k) && !Nil.is(x[k])) {
        y[k] = compact(x[k]);
      }
    }
  }
  else if (Arr.is(x)) {
    y = [];
    for (var i = 0, len = x.length; i < len; i++) {
      if (!Nil.is(x[i])) {
        y.push(compact(x[i]));
      }
    }
  }
  return y;
}

function fold(xs, init, f) {
  assert(Arr.is(xs));
  assert(Func.is(f));
  var ret = init;
  for (var i = 0, len = xs.length; i < len; i++) {
    ret = f(ret, xs[i]);
  }
  return ret;
}

// unique(['a', 'b', 'a']) => ['a', 'b']
function unique(xs) {
  assert(Arr.is(xs));
  var ret = [];
  for (var i = 0, len = xs.length; i < len; i++) {
    for (var j = i + 1; j < len; j++) {
      if (xs[i] === xs[j]) {
        j = ++i;
      }
    }
    ret.push(xs[i]);
  }
  return ret;
}

//     flatten([1, 2, [3, 4]]) => [1, 2, 3, 4]
function flatten(xs) {
  var ys = [];
  for (var i = 0, len = xs.length; i < len; i++) {
    if (Arr.is(xs[i])) {
      ys = ys.concat(xs[i]);
    }
    else {
      ys.push(xs[i]);
    }
  }
  return ys;
}

// un nuovo array senza i primi n elementi di xs
//     drop(2, [1, 2, 3]) => [1]
function drop(n, xs) {
  assert(Natural.is(n));
  return Array.prototype.slice.call(xs, n);
}

// un nuovo array contenente i primi n elementi di xs
//     take(2, [1, 2, 3]) => [1, 2]
function take(n, xs) {
  assert(Natural.is(n));
  return Array.prototype.slice.call(xs, 0, n);
}

function trim_left(s) {
  return s.replace(/^\s\s*/, '');
}

function trim_right(s) {
  return s.replace(/\s\s*$/, '');
}

function pad_time(n) {
  return pad_left(String(n), 2, "0");
}

// una mappa contenente le diverse parti di una data
// (yyyy, MM, dd, ...)
function date_parts(millis) {
  assert(is_integer(millis));
  var d = new Date(millis);
  return {
    YY: String(d.getFullYear()),
    MM: pad_time(d.getMonth() + 1),
    DD: pad_time(d.getDate()),
    hh: pad_time(d.getHours()),
    mm: pad_time(d.getMinutes())
  };
}

// una stringa declinata al singolare o al plurale a seconda
// dell'argomento opts.
// Il bundle è un oggetto che contiene le tre chiavi
//
// - zero: usato se opts.count = 0
// - one: usato se opts.count = 1
// - other: usato se opts.count > 1
//
// oppure una stringa, nel qual caso il risultato non viene declinato.
//
// L'intero oggetto opts viene passato come locals al template scelto dalla
// procedura precedente.
//
//     var bundle = {
//         zero: 'nessuna casa',
//         one: 'una casa',
//         other: '<%= count %> case <%= color %>'
//     };
//
//     pluralize(bundle, {count: 0})); => 'nessuna casa'
//     pluralize(bundle, {count: 1})); => 'una casa'
//     pluralize(bundle, {count: 5, color: 'rosse'})); => '5 case rosse'
//
//
function pluralize(bundle, opts) {
  assert(Union([Str, Obj]).is(bundle));
  assert(Obj.is(opts));

  var src = Obj.is(bundle) ?
    opts.count === 0 ? bundle.zero :
    opts.count === 1 ? bundle.one :
    bundle.other :
    bundle;
  return template(src)(opts);
}

function truncate(s, max_length) {
  assert(Str.is(s));
  assert(Natural.is(max_length));
  //var ELLIPSIS = '\u2026';
  var ELLIPSIS = '...';
  return s.length <= max_length ? s : s.substring(0, max_length - ELLIPSIS.length) + ELLIPSIS;
}

// range(1, 10, 2) => [1, 3, 5, 7, 9]
function range(start, stop, step) {
  assert(Int.is(start));
  assert(Int.is(stop));
  assert(Int.is(step));

  var ret = [];
  stop = Math.abs(stop);
  for (var i = start; Math.abs(i) <= stop; i = i + step) {
    ret.push(i);
  }
  return ret;
}

//     pad_left('foo', 2, 'x') => 'foo'
//     pad_left('foo', 5, 'x') => 'xxfoo'
function pad_left(s, min_length, c) {
  return pad(s, min_length, c, 'left');
}

function pad_right(s, min_length, c) {
  return pad(s, min_length, c, 'right');
}

function pad_center(s, min_length, c) {
  return pad(s, min_length, c, 'center');
}

function pad(s, min_length, c, type) {
  assert(Str.is(s));
  assert(Natural.is(min_length));
  assert(Str.is(c));
  assert(c.length === 1);
  assert(type in {
    'left': 1,
    'right': 1,
    'center': 1
  });
  var length = s.length;
  min_length = Math.max(length, min_length);
  var pad_left = '';
  var pad_right = '';
  if (type === 'left') {
    pad_left = repeat(c, min_length - length);
  }
  else if (type === 'right') {
    pad_right = repeat(c, min_length - length);
  }
  else {
    var left = parseInt(min_length / 2, 10) - parseInt(length / 2, 10);
    pad_left = repeat(c, left);
    pad_right = repeat(c, min_length - length - left);
  }
  return pad_left + s + pad_right;
}

function repeat(c, times) {
  return Arr.of_length(times + 1).join(c);
}

function noop() {}

function is_cookies_enabled() {
  var TEST_COOKIE = 'test_cookie';
  $.cookie(TEST_COOKIE, 'true');
  if ($.cookie(TEST_COOKIE)) {
    $.cookie(TEST_COOKIE, null); // delete the cookie
    return true;
  }
  return false;
}

// event emitter
var Emitter = {

  on: function(name, f) {
    assert(Str.is(name));
    assert(Func.is(f));
    this.events[name] = (this.events[name] || []);
    this.events[name].push(f);
    return this;
  },

  off: function(name, f) {
    assert(Maybe(Str).is(name));
    assert(Maybe(Func).is(f));
    var l = arguments.length;
    if (l === 0) {
      this.events = {};
    }
    else if (l === 1) {
      delete this.events[name];
    }
    else if (this.events[name]) {
      this.events[name] = this.events[name].filter(function(cb) {
        return cb !== f;
      });
    }
    return this;
  },

  emit: function(name, args) {
    assert(Str.is(name));
    var fs = this.events[name];
    if (fs) {
      for (var i = 0, len = fs.length; i < len; i++) {
        fs[i](args);
      }
    }
    return this;
  },

  once: function(name, f) {
    assert(Str.is(name));
    assert(Func.is(f));
    var self = this;
    var on = function(args) {
      self.off(name, on);
      f(args);
    };
    this.on(name, on);
    return this;
  }

};

// sistema di templating
function template(src, opt_settings) {
  assert(Str.is(src));
  opt_settings = opt_settings || template.jsp;
  assert(Obj.is(opt_settings));

  var tmpl = 'var __p=[],print=function(){__p.push.apply(__p,arguments);};' +
    'with(obj||{}){__p.push(\'' +
    src.replace(/\\/g, '\\\\')
    .replace(/'/g, "\\'")
    .replace(opt_settings.interpolate, function(match, code) {
      return "'," + code.replace(/\\'/g, "'") + ",'";
    })
    .replace(opt_settings.evaluate || null, function(match, code) {
      return "');" + code.replace(/\\'/g, "'")
        .replace(/[\r\n\t]/g, ' ') + "__p.push('";
    })
    .replace(/\r/g, '\\r')
    .replace(/\n/g, '\\n')
    .replace(/\t/g, '\\t') + "');}return __p.join('');";

  return new Function('obj', tmpl); // eslint-disable-line no-new-func
}

template.jsp = {
  evaluate: /<%([\s\S]+?)%>/g,
  interpolate: /<%=([\s\S]+?)%>/g
};

template.mustache = {
  evaluate: /{{([\s\S]+?)}}/g,
  interpolate: /{{=([\s\S]+?)}}/g
};

var template_cache = {};

template.store = function(id, t) {
  template_cache[id] = t;
  return t;
};

template.of = function(id) {
  return template_cache[id];
};

// Da usare quando il sorgente del template non può contenere <, >
function mustache(src) {
  return template(src, template.mustache);
}

// # Input
// Armamentario per gestire il recupero e la validazione dei dati di input

// rappresenta una regola di validazione fallita, con il name che indica
// quale è la regola fallita, e args che può contenere info più specifiche
// sulla ragione del perchè è fallita e possono essere sfruttate in fase
// di traduzione della regola in un formato leggibile da un umano
function Rule(name, args) {
  args = args || [];
  assert(Str.is(name));
  assert(Arr.is(args));
  this.name = name;
  this.args = args;
  return freeze(this);
}

Rule.is = function(x) {
  return x instanceof Rule;
};

Rule.of = function(x) {
  assert(Obj.is(x));
  return new Rule(
    Str.of(x.name),
    Arr.of(x.args)
  );
};

(function() {

  var localizers = {};

  Rule.add_localizer = function(name, localizer) {
    assert(!localizers.hasOwnProperty(name));
    localizers[name] = localizer;
    return Rule;
  };

  Rule.get_localizer = function(name) {
    return localizers[name];
  };

})();

Rule.bundle = function(locale) {
  return locale.language_bundle().validation;
};

// traduce una regola di validazione fallita in un messaggio da mostrare all'utente.
// L'argomento deve essere un locale e non semplicemente una lingua
// perchè in generale la traduzione potrebbe richiedere la formattazione
// di numeri (ad esempio il messaggio "almeno 1.000 caratteri").
Rule.prototype.localize = function(locale) {
  //assert(Locale.is(locale)); //fixme
  return Rule.get_localizer(this.name)(this.args, locale);
};

Rule
  .add_localizer('required', function(args, locale) {
    return Rule.bundle(locale).required;
  })
  .add_localizer('format', function(args, locale) {
    return Rule.bundle(locale)[args[0]];
  })
  .add_localizer('max_length', function(args, locale) {
    var max_length = args[0];
    return pluralize(Rule.bundle(locale).max_length, {
      arg: locale.format_integer(max_length),
      count: max_length
    });
  })
  .add_localizer('min_length', function(args, locale) {
    var min_length = args[0];
    return pluralize(Rule.bundle(locale).min_length, {
      arg: locale.format_integer(min_length),
      count: min_length
    });
  })
  .add_localizer('max', function(args, locale) {
    var max = args[0];
    return template(Rule.bundle(locale).max)({
      arg: locale.format_integer(max)
    });
  })
  .add_localizer('min', function(args, locale) {
    var min = args[0];
    return template(Rule.bundle(locale).min)({
      arg: locale.format_integer(min)
    });
  })
  .add_localizer('number', function(args, locale) {
    return Rule.bundle(locale).number;
  })
  .add_localizer('date', function(args, locale) {
    return Rule.bundle(locale).date;
  })
  .add_localizer('integer', function(args, locale) {
    return Rule.bundle(locale).integer;
  })
  .add_localizer('any', function(args, locale) {
    return Rule.bundle(locale).any;
  })
  .add_localizer('min_items', function(args, locale) {
    var min_items = args[0];
    return pluralize(Rule.bundle(locale).min_items, {
      count: min_items,
      arg: min_items
    });
  });

// rappresenta il risultato di una validazione
// nel campo x c'è il valore validato, eventualmente modificato
// dal processo di validazione (ad esempio un parsing di un numero)
// nel campo rule la eventuale prima regola di validazione fallita
// altrimenti null
function Validation(x, rule) {
  assert(Maybe(Union([JSON_Value, Arr])).is(x));
  assert(Maybe(Rule).is(rule));
  this.x = x;
  this.rule = rule;
  return freeze(this);
}

Validation.is = function(x) {
  return x instanceof Validation;
};

Validation.of = function(x) {
  assert(Obj.is(x));
  return new Validation(
    Maybe(Union([JSON_Value, Arr])).of(x.x),
    Maybe(Rule).of(x.rule)
  );
};

// rappresenta il formato di un numero
// Per validare un numero immesso come stringa, ovvero per parsarlo,
// ho bisogno prima di sapere in che formato è stato immesso
function Number_Format(decimal_symbol, digits, grouping_symbol, infinity, negative_suffix, positive_suffix) {
  assert(Str.is(decimal_symbol));
  assert(Natural.is(digits));
  assert(Str.is(grouping_symbol));
  assert(Str.is(infinity));
  assert(Str.is(negative_suffix));
  assert(Str.is(positive_suffix));
  this.decimal_symbol = decimal_symbol;
  this.digits = digits;
  this.grouping_symbol = grouping_symbol;
  this.infinity = infinity;
  this.negative_suffix = negative_suffix;
  this.positive_suffix = positive_suffix;
  return freeze(this);
}

Number_Format.is = function(x) {
  return x instanceof Number_Format;
};

Number_Format.of = function(x) {
  assert(Obj.is(x));
  return new Number_Format(
    Str.of(x.decimal_symbol),
    Natural.of(x.digits),
    Str.of(x.grouping_symbol),
    Str.of(x.infinity),
    Str.of(x.negative_suffix),
    Str.of(x.positive_suffix)
  );
};

// se s è parsabile un numero altrimenti null
Number_Format.prototype.parse_number = function(s) {
  assert(Str.is(s));

  var escape_regexp = function(s) {
    return s.replace(/([.*+?^${}()|[\]\/\\])/g, '\\$1');
  };

  // elimina i simboli di raggruppamento delle migliaia
  // e il simbolo della virgola con la virgola JavaScript
  var make_parseable = function(fmt, s) {
    var grouping_symbol_re = new RegExp(escape_regexp(fmt.grouping_symbol), 'gm');
    var decimal_symbol_re = new RegExp(escape_regexp(fmt.decimal_symbol), 'gm');
    var without_grouping = s.replace(grouping_symbol_re, "");
    return without_grouping.replace(decimal_symbol_re, ".");
  };

  var parseable = make_parseable(this, s);
  return is_numeric(parseable) ? parseFloat(parseable) :
    parseable === this.infinity ? Infinity :
    parseable === this.negative_suffix + this.infinity ?
    -Infinity : null;
};

var Validation_Monad = (function() {

  // Haskell return
  var unit = function(x) {
    return new Validation(x, null);
  };

  // Haskell >>=
  var bind = function(validation, f) {
    assert(Validation.is(validation));
    assert(Func.is(f));

    if (validation.x === null) {
      return validation;
    }
    else if (validation.rule) {
      return validation;
    }
    return f(validation.x);
  };

  var required = function(b) {
    assert(Bool.is(b));
    return function(x) {
      if (Str.is(x)) {
        x = x.trim();
        if (x.length === 0) {
          x = null;
        }
      }
      if (b && x === null) {
        return new Validation(x, new Rule('required'));
      }
      return unit(x);
    };
  };

  var max_length = function(length) {
    assert(Natural.is(length));
    return function(x) {
      if (x.length > length) {
        return new Validation(x, new Rule("max_length", [length]));
      }
      return unit(x);
    };
  };

  var min_length = function(length) {
    assert(Natural.is(length));
    return function(x) {
      if (x.length < length) {
        return new Validation(x, new Rule("min_length", [length]));
      }
      return unit(x);
    };
  };

  var format = function(sf) {
    assert(Str_Format.is(sf));
    return function(x) {
      var p = Str_Format.formats[sf];
      if (!p(x)) {
        return new Validation(x, new Rule("format", [sf]));
      }
      return unit(x);
    };
  };

  var any_of = function(values, is_case_insensitive) {
    assert(Arr.is(values));
    return function(x) {
      var lower = String(x).toLowerCase();
      if (all(values, function(value) {
          return is_case_insensitive ?
            String(value).toLowerCase() !== lower :
            value !== x;
        })) {
        return new Validation(x, new Rule("any", [values]));
      }
      return unit(x);
    };
  };

  var is_num = function(number_format) {
    assert(Number_Format.is(number_format));
    return function(x) {
      x = number_format.parse_number(x);
      if (x === null || !isFinite(x)) {
        return new Validation(x, new Rule("number"));
      }
      return unit(x);
    };
  };

  var max = function(i) {
    assert(Num.is(i));
    return function(x) {
      if (x > i) {
        return new Validation(x, new Rule("max", [i]));
      }
      return unit(x);
    };
  };

  var min = function(i) {
    assert(Num.is(i));
    return function(x) {
      if (x < i) {
        return new Validation(x, new Rule("min", [i]));
      }
      return unit(x);
    };
  };

  var is_int = function(x) {
    if (!is_integer(x)) {
      return new Validation(x, new Rule("integer"));
    }
    return unit(x);
  };

  var bool = function(x) {
    if (!Bool.is(x)) {
      return new Validation(x, new Rule("boolean"));
    }
    return unit(x);
  };

  var array = function(x) {
    if (!Arr.is(x)) {
      return new Validation(x, new Rule("array"));
    }
    return unit(x);
  };

  var min_items = function(min) {
    assert(Natural.is(min));
    return function(x) {
      if (x.length < min) {
        return new Validation(x, new Rule("min_items", [min]));
      }
      return unit(x);
    };
  };

  var is_ranking = function() {
    return function(x) {
      var answer = {}
      for (var i = 0; i < x.length; i++) {
        if (!answer[x[i][1]]) {
          answer[x[i][1]] = 1
        }
      }
      if (x.length !== keys(answer).length) {
        return new Validation({x: x, rule: new Rule({name: "is_ranking"})});
      }
      return unit(x);
    };
  };


  var date = function(required) {
    assert(Bool.is(required));
    return function(x) {
      assert(List(Str).is(x));
      if (all(x, function(y) {
          return y === '';
        }) && !required) {
        return unit(null);
      }
      x = x.map(function(y) { // converto le parti in interi
        return parseInt(y, 10);
      });
      if (x.length === 5) { // la data è accurata
        if (!Accurate_Date.is(x)) { // controllo che sia una data valida
          return new Validation(x, new Rule("date"));
        }
        x[1] = x[1] - 1; // in JavaScript i mesi sono zero based
        return unit(new Date(x[0], x[1], x[2], x[3], x[4], 0).getTime());
      }
      else {
        if (!Short_Date.is(x)) { // controllo che sia una data valida
          return new Validation(x, new Rule("date"));
        }
        x[1] = x[1] - 1; // in JavaScript i mesi sono zero based
        return unit(new Date(x[0], x[1], x[2]).getTime());
      }
    };
  };

  var pipe = function(x, actions) {
    assert(Str.is(x) || Arr.is(x) || Bool.is(x));
    return fold(actions, unit(x), bind);
  };

  return {
    unit: unit,
    bind: bind,
    pipe: pipe,
    required: required,
    max_length: max_length,
    min_length: min_length,
    format: format,
    any: any_of,
    is_number: is_num,
    is_integer: is_int,
    max: max,
    min: min,
    bool: bool,
    array: array,
    min_items: min_items,
    is_ranking: is_ranking,
    date: date
  };

})();

// # Schemas

function Str_Schema(required, max_length, min_length, format, any, is_case_insensitive) {
  assert(Maybe(Bool).is(required));
  assert(Maybe(Natural).is(max_length));
  assert(Maybe(Natural).is(min_length));
  assert(Maybe(Str_Format).is(format));
  assert(Maybe(List(Str)).is(any));
  assert(Maybe(Bool).is(is_case_insensitive));
  this.type = 'string';
  this.required = required;
  this.max_length = max_length;
  this.min_length = min_length;
  this.format = format;
  this.any = any;
  this.is_case_insensitive = is_case_insensitive;
  return freeze(this);
}

Str_Schema.is = function(x) {
  return x instanceof Str_Schema;
};
Str_Schema.of = function(x) {
  assert(Obj.is(x));
  return new Str_Schema(
    Maybe(Bool).of(x.required),
    Maybe(Natural).of(x.max_length),
    Maybe(Natural).of(x.min_length),
    Maybe(Str_Format).of(x.format),
    Maybe(List(Str)).of(x.any),
    Maybe(Bool).of(x.is_case_insensitive)
  );
};

var Str_Format = Subtype(Str, function(x) {
  return Str_Format.formats.hasOwnProperty(x);
});

Str_Format.formats = {
  email: is_email,
  url: is_url,
  https_url: is_https_url,
  digits: is_digits,
  color: is_color,
  uuid: is_uuid
};

Str_Schema.prototype.validate = function(s) {
  assert(Str.is(s));
  var actions = [];
  actions.push(Validation_Monad.required(!!this.required));
  if (!Nil.is(this.max_length)) {
    actions.push(Validation_Monad.max_length(this.max_length));
  }
  if (!Nil.is(this.min_length)) {
    actions.push(Validation_Monad.min_length(this.min_length));
  }
  if (!Nil.is(this.format)) {
    actions.push(Validation_Monad.format(this.format));
  }
  if (!Nil.is(this.any)) {
    actions.push(Validation_Monad.any(this.any, this.is_case_insensitive));
  }
  return Validation_Monad.pipe(s, actions);
};

function Num_Schema(required, max, min, integer, any) {
  assert(Maybe(Bool).is(required));
  assert(Maybe(Num).is(max));
  assert(Maybe(Num).is(min));
  assert(Maybe(Bool).is(integer));
  assert(Maybe(List(Num)).is(any));
  this.type = 'number';
  this.required = required;
  this.max = max;
  this.min = min;
  this.integer = integer;
  this.any = any;
  return freeze(this);
}

Num_Schema.is = function(x) {
  return x instanceof Num_Schema;
};

Num_Schema.of = function(x) {
  assert(Obj.is(x));
  return new Num_Schema(
    Maybe(Bool).of(x.required),
    Maybe(Num).of(x.max),
    Maybe(Num).of(x.min),
    Maybe(Bool).of(x.integer),
    Maybe(List(Num)).of(x.any)
  );
};

Num_Schema.prototype.to_computation = function(number_format) {
  assert(Maybe(Number_Format).is(number_format));
  var actions = [];
  actions.push(Validation_Monad.required(!!this.required));
  if (number_format) {
    actions.push(Validation_Monad.is_number(number_format));
  }
  if (!Nil.is(this.max)) {
    actions.push(Validation_Monad.max(this.max));
  }
  if (!Nil.is(this.min)) {
    actions.push(Validation_Monad.min(this.min));
  }
  if (this.integer) {
    actions.push(Validation_Monad.is_integer);
  }
  if (!Nil.is(this.any)) {
    actions.push(Validation_Monad.any(this.any, false));
  }
  return function(x) {
    return Validation_Monad.pipe(x, actions);
  };
};

Num_Schema.prototype.validate_num = function(n) {
  assert(Num.is(n));
  return this.to_computation()(n);
};

Num_Schema.prototype.validate = function(s, locale) {
  assert(Str.is(s));
  assert(Locale.is(locale));
  var number_format = locale.to_number_format();
  return this.to_computation(number_format)(s);
};

function Bool_Schema(any) {
  assert(Maybe(List(Bool)).is(any));
  this.type = 'boolean';
  this.any = any;
  return freeze(this);
}

Bool_Schema.is = function(x) {
  return x instanceof Bool_Schema;
};

Bool_Schema.of = function(x) {
  assert(Obj.is(x));
  return new Bool_Schema(
    Maybe(List(Bool)).of(x.any)
  );
};

Bool_Schema.prototype.validate = function(b) {
  assert(Bool.is(b));
  var actions = [];
  actions.push(Validation_Monad.bool);
  if (!Nil.is(this.any)) {
    actions.push(Validation_Monad.any(this.any, false));
  }
  return Validation_Monad.pipe(b, actions);
};

function Date_Schema(required) {
  assert(Maybe(Bool).is(required));
  this.type = 'date';
  this.required = required;
  return freeze(this);
}

Date_Schema.is = function(x) {
  return x instanceof Date_Schema;
};

Date_Schema.of = function(x) {
  assert(Obj.is(x));
  return new Date_Schema(
    Maybe(Bool).of(x.required)
  );
};

Date_Schema.prototype.validate = function(a) {
  var actions = [];
  actions.push(Validation_Monad.date(!!this.required));
  return Validation_Monad.pipe(a, actions);
};

function Arr_Schema(min_items, is_ranking) {
  assert(Maybe(Natural).is(min_items));
  assert(Maybe(Bool).is(is_ranking));
  this.type = 'array';
  this.min_items = min_items;
  this.is_ranking = is_ranking;
  return freeze(this);
}

Arr_Schema.is = function(x) {
  return x instanceof Arr_Schema;
};

Arr_Schema.of = function(x) {
  assert(Obj.is(x));
  return new Arr_Schema(
    Maybe(Natural).of(x.min_items),
    Maybe(Bool).of(x.is_ranking)
  );
};

Arr_Schema.prototype.validate = function(xs) {
  assert(Arr.is(xs));
  var actions = [];
  actions.push(Validation_Monad.array);
  if (!Nil.is(this.min_items)) {
    actions.push(Validation_Monad.min_items(this.min_items));
  }
  if (!Nil.is(this.is_ranking)) {
    actions.push(Validation_Monad.is_ranking());
  }
  return Validation_Monad.pipe(xs, actions);
};


var Schema = Union([Str_Schema, Num_Schema, Bool_Schema, Arr_Schema]);

Schema.of = function(obj) {
  assert(Obj.is(obj));
  var schemas = {
    string: Str_Schema,
    number: Num_Schema,
    'boolean': Bool_Schema,
    array: Arr_Schema
  };
  assert(Func.is(schemas[obj.type]));
  return schemas[obj.type].of(obj);
};

// # Output
// funzioni di formattazione

Amount.format = function(locale, currency, amount) {
  //assert(Locale.is(locale));
  assert(Currency.is(currency));
  assert(Amount.is(amount));
  var bundle = locale.locale_bundle();
  assert(bundle);
  var symbol = bundle.currency[currency];
  return symbol + ' ' + locale.format_number(amount);
};

Num.format = function(n, number_format) {
  assert(Num.is(n) || !isFinite(n));
  assert(Number_Format.is(number_format));

  var add_grouping_symbol = function(s, grouping_symbol) {
    var re = /(\d+)(\d{3})/;
    var symbols = parseInt(s.length / 3, 10);
    Arr.of_length(symbols).forEach(function() {
      s = s.replace(re, "$1" + grouping_symbol + "$2");
    });
    return s;
  };

  var format_abs = function(abs, fmt) {
    var s = abs.toFixed(fmt.digits);
    var xs = s.split(".");
    var is_decimal = xs.length > 1;
    var integers = xs[0];
    var decimals = xs[1];
    var grouping_symbol = fmt.grouping_symbol;
    var integral_part = grouping_symbol ? add_grouping_symbol(integers, grouping_symbol) : integers;
    var decimal_part = is_decimal ? (fmt.decimal_symbol) + (decimals) : "";
    return (integral_part) + (decimal_part);
  };

  var suffix = number_format[(n) >= (0) ? 'positive_suffix' : 'negative_suffix'];
  var abs = Math.abs(n);
  return (suffix) + (abs === Infinity ? number_format.infinity : format_abs(abs, number_format));
};

Datetime.format = function(millis, pattern) {
  assert(Datetime.is(millis));
  assert(Str.is(pattern));
  return template(pattern)(date_parts(millis));
};

JSON_Value.format = function(locale, schema, value) {
  //assert(Locale.is(locale)); fixme
  //assert(Schema.is(schema)); fixme
  //assert(Maybe(JSON_Value).is(value)); fixme

  if (Nil.is(value)) {
    return '';
  }
  if (schema.type === 'number') {
    return schema.integer ?
      locale.format_integer(value) :
      locale.format_number(value, schema.digits);
  }
  return String(value);
};

// micro markdown parser

var micromd = (function() {

  // converte un tag in html
  // - i p sono convertiti semplicemente in testo con gli a capo
  // sostituiti da <br/>
  // - le liste con le liste corrispondenti ol, ul a seconda che
  // siano ordinate o no
  var render_tag = function(tag) {
    var name = tag.name;
    var args = tag.args;
    return name === 'p' ?
      args.join('<br/>') :
      dom[name](args.map(function(x) {
        return dom.li(x.replace(lists[name], '')); // toglie "- " o "+ "
      }).join(''));
  };

  // elenco trasformazioni inline
  var inline = {
    strong: function(src) {
      return src.replace(/(\*\*)(?=\S)([^\r]*?\S[*]*)\1/g, "<strong>$2</strong>");
    },
    em: function(src) {
      return src.replace(/(\*)(?=\S)([^\r]*?\S)\1/g, "<em>$2</em>");
    },
    link: function(src) {
      return src.replace(/(\[((?:\[[^\]]*\]|[^\[\]])*)\]\([ \t]*()<?(.*?)>?[ \t]*((['"])(.*?)\6[ \t]*)?\))/g, function(wholeMatch, m1, text, m3, url) {
        const isMailto = url.indexOf('mailto:') === 0;
        const self = url.indexOf('self:') === 0;
        const isJS = url.indexOf('javascript:') === 0; // eslint-disable-line no-script-url
        let target = '_blank';
        if ( isMailto )  {
          target = '';
        }
        if ( self )  {
          target = '_self';
          url = url.substring(5, url.length);
        }
        if ( isJS )  {
          target = '#';
        }
        // non uso attr() altrimenti farei due volte l'escape_html()
        return '<a href="' + url + '" target="' + target + '">' + text + '</a>';
      });
    }
  };

  var lists = {
    ul: /^- /,
    ol: /^\+ /
  };

  // data una linea quel'è il tag più appropriato per
  // farne il rendering
  var detect_tag = function(line) {
    return lists.ul.exec(line) ?
      'ul' :
      lists.ol.exec(line) ?
      'ol' :
      'p';
  };

  return function(md) {

    assert(Str.is(md));

    // uniformo gli a capo a \n
    var uniformed = md.replace(/\r\n|\r/g, '\n');

    // elimino tag molesti
    var escaped = escape_html(uniformed);

    // applico le trasformazioni inline
    var inlined = fold(['link', 'strong', 'em'], escaped, function(ret, x) {
      return inline[x](ret);
    });

    // divido il sorgente ottenuto in blocchi divisi dagli a capo
    // e faccio un trim delle righe
    var lines = inlined.split('\n').map(function(s) {
      return s.trim();
    });

    // analizzo i blocchi per determinare i tag
    var tags = [];
    var old_tag;
    lines.forEach(function(line) {
      var new_tag = detect_tag(line);
      if (new_tag !== old_tag) {
        tags.push({
          name: new_tag,
          args: []
        });
      }
      tags[tags.length - 1].args.push(line);
      old_tag = new_tag;
    });

    // render dei tag trovati
    return tags.map(render_tag).join('');
  };

})();

// # html

function escape_html(s) {
  assert(Str.is(s));

  return s.replace(/&(?!\w+;)/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/\//g, '&#x2F;');
}

function abbr(s, max_length) {
  assert(Str.is(s));
  assert(Natural.is(max_length));
  return "<span" + attr2("title", s) + ">" + escape_html(truncate(s, max_length)) + "</span>";
}

// # renderers di basso livello degli oggetti html più comuni
// - textbox
// - textarea
// - gruppo di radio
// - select
// - data
// - table

function radio_group(options, name, attrs, value) {
  attrs = attrs || {};
  attrs['class'] = attrs['class'] || [];

  var opt = function(option) {
    assert(Str_Option.is(option));
    return '<div class="group-input">' + dom.radio({
      value: option[0],
      name: name,
      checked: option[0] === value
    }) + '</div><div class="group-label">' + option[1] + '</div>';
  };

  return dom.div(options.map(opt).join(''), attrs);
}

function date_option(i) {
  var s = pad_time(i);
  return [s, s];
}

var EMPTY_OPTION = ['', '-'];
var DAYS = [EMPTY_OPTION].concat(range(1, 31, 1).map(date_option));
var MONTHS = [EMPTY_OPTION].concat(range(1, 12, 1).map(date_option));
var HOURS = [EMPTY_OPTION].concat(range(0, 23, 1).map(date_option));
var MINUTES = [EMPTY_OPTION].concat(range(0, 59, 1).map(date_option));

function date(attrs, value, order) {
  attrs = attrs || {};
  var parts = !Nil.is(value) ? date_parts(value) : {};
  var ui_parts = {
    DD: dom.select_of_options(DAYS, {
      "class": "days"
    }, parts.DD),
    MM: dom.select_of_options(MONTHS, {
      "class": "months"
    }, parts.MM),
    YY: dom.textbox({
      size: 4,
      maxlength: 4,
      "class": "years",
      value: parts.YY
    }),
    hh: dom.select_of_options(HOURS, {
      "class": "hours"
    }, parts.hh),
    mm: dom.select_of_options(MINUTES, {
      "class": "minutes"
    }, parts.mm)
  };

  return dom.div(order.map(function(part) {
    return ui_parts[part];
  }).join(''), attrs);
}

function table(columns, rows, attrs) {
  assert(List(Str).is(columns));
  //assert(List(List(Str)).is(rows));
  assert(Maybe(Obj).is(attrs));
  var html = '<table' + attr((attrs || {})) + '>';
  html += table.thead(columns);
  html += table.tbody(rows);
  html += '</table>';
  return html;
}

table.tbody = function(rows) {
  var html = ['<tbody>'];
  rows.forEach(function(row, i) {
    html.push('<tr class="', is_even(i) ? 'odd' : 'even', ' tr_', i, '">');
    row.forEach(function(cell, j) {
      html.push('<td class="td_', j, '">', cell, '</td>');
    });
    html.push('</tr>');
  });
  html.push('</tbody>');
  return html.join('');
};

table.thead = function(columns) {
  var html = '<thead><tr>';
  columns.forEach(function(column, j) {
    html += '<th class="th_' + j + '">' + column + '</th>';
  });
  html += '</tr></thead>';
  return html;
};

function attr2(name, value) {
  assert(Attr_Name.is(name));

  if (!Attr_Value.is(value)) {
    return '';
  }

  var n = name.trim();
  // trasformo value in una stringa; value potrebbe essere un numero, un array
  // nel caso name sia 'class' oppure un oggetto se name = 'style'
  var v = String(
    n === 'class' && Arr.is(value) ?
    value.join(' ') :
    n === 'style' && Obj.is(value) ?
    css(value) :
    value
  );
  return ' ' + n + '="' + escape_html(v.trim()) + '"';
}

function attr(obj) {
  assert(Obj.is(obj));
  var ret = [];
  for (var k in obj) {
    ret.push(attr2(k, obj[k]));
  }
  return ret.sort().join(''); // li ordino in modo che sia più facile fare i test
}

function css(obj) {
  assert(Obj.is(obj));
  var ret = [];
  for (var k in obj) {
    ret.push(css2(k, obj[k]));
  }
  return ret.sort().join(''); // li ordino in modo che sia più facile fare i test
}

function css2(name, value) {
  assert(Attr_Name.is(name));
  assert(Maybe(JSON_Value).is(value));

  if (Nil.is(value)) {
    return '';
  }

  var background_image_of_url = function(url) {
    url = url.replace("(", "%28").replace(")", "%29");
    return "url(" + url + ")";
  };

  var n = name.trim();
  // - se lo stile è background-image devo assicurarmi che l'url
  // contenuto in value non abbia parentesi e wrapparlo con url(...)
  // - se value è un numero allora sono pixel e aggiungo
  // il suffisso "px"
  var v = String(
    name === 'background-image' ?
    background_image_of_url(value) :
    Num.is(value) ?
    value + "px" :
    value
  );
  return n + ": " + v.trim() + ";";
}

// divide gli stili che riguardano i margini dagli altri
// serve a costruire input per la Form
function split_margins(style) {

  function is_margin(k) {
    return k.indexOf('margin') !== -1;
  }

  style = style || {};
  var ret = {
    margins: {},
    other: {}
  };
  for (var k in style) {
    if (is_margin(k)) {
      ret.margins[k] = style[k];
    }
    else {
      ret.other[k] = style[k];
    }
  }
  return ret;
}

var Message_Type = Enum('success error warning danger'.split(' '));

function Message(type, id, args) {
  assert(Message_Type.is(type));
  assert(Str.is(id));
  assert(Maybe(Obj).is(args));
  this.type = type;
  this.id = id;
  this.args = args;
  return freeze(this);
}

Message.is = function(x) {
  return x instanceof Message;
};

Message.of = function(x) {
  assert(Obj.is(x));
  return new Message(
    Message_Type.of(x.type),
    Str.of(x.id),
    Maybe(Obj).of(x.args)
  );
};

Message.prototype.translate = function(locale) {
  var src = this.bundle(locale)[this.id];
  return template(src)(this.args);
};

Message.to_std_message = function(type, body, closeable) {
  return [
    '<div class="alert ' + type + '">', (closeable ? '<a class="close" href="#">&times;</a>' : ''), // aggiungo la X di chiusura, se è il caso
    body,
    '</div>'
  ].join('');
};

Message.to_html = function(message, locale) {
  assert(Maybe(Message).is(message));
  assert(Locale.is(locale));
  if (!message) {
    return '';
  }
  return Message.to_std_message(message.type, micromd(message.translate(locale)), false);
};

// Widget

var Widget_Interface = Interface({
  to_html: Func,
  start: Func,
  stop: Func
});

function Widget(to_html, start, stop) {
  assert(Union([Str, Func]).is(to_html));
  assert(Maybe(Func).is(start));
  assert(Maybe(Func).is(stop));
  this.to_html = Str.is(to_html) ? function() {
    return to_html;
  } : to_html;
  this.start = start || noop;
  this.stop = stop || noop;
  return freeze(this);
}

Widget.concat = function(widgets, tmpl) {
  assert(List(Widget_Interface).is(widgets));

  // di default concateno i widget uno dopo l'altro
  tmpl = tmpl || widgets.map(function(w, i) {
    return '<%= $' + i + ' %>';
  }).join('');

  var to_html = function() {
    var locals = {};
    widgets.forEach(function(w, i) {
      locals['$' + i] = w.to_html();
    });
    return template(tmpl)(locals);
  };

  var start = function() {
    widgets.forEach(function(w) {
      w.start();
    });
  };

  var stop = function() {
    widgets.forEach(function(w) {
      w.stop();
    });
  };

  return new Widget(to_html, start, stop);

};

// Form

var Form_Cell = Union([Str, Obj]);

function Form(config, data, locale) {

  assert(Obj.is(config));
  assert(Maybe(Obj).is(config.attrs));
  assert(Obj.is(data));
//  assert(Locale.is(locale));

  var self = this;
  this.input_list = [];
  this.input_map = {};
  this.stacked = !!config.stacked;
  this.attrs = config.attrs || {};
  this.rows = config.rows.map(function(row) {
    return row.map(function(cell) {
      assert(Form_Cell.is(cell));
      if (Str.is(cell)) {
        return cell;
      }
      else {
        assert(Str.is(cell.type)); // un input deve avere un tipo
        assert(Str.is(cell.id)); // un input deve avere un id
        assert(!self.input_map[cell.id]); // controllo che gli id siano tutti diversi
        var input_ctor = Form.get_input(cell.type);
        assert(Func.is(input_ctor), 'unknown input ' + cell.type); // controllo che l'input sia censito
        var input = input_ctor(cell);
        self.input_list.push(input);
        self.input_map[input.id] = input;
        return input;
      }
    });
  });
  this.data = data;
  this.locale = locale;
  return freeze(this);
}

Form.is = function(x) {
  return x instanceof Form;
};

// per censire i tipi di input provvedo ad un paio di metodi
(function() {

  var inputs = {};

  Form.add_input = function(type, input_ctor) {
    assert(!inputs.hasOwnProperty(type));
    inputs[type] = input_ctor;
    return Form;
  };

  Form.get_input = function(id) {
    return inputs[id].of ? inputs[id].of : inputs[id];
  };

})();

Form.prototype.to_html = function(context) {

  function form(stacked, attrs, rows) {

    assert(Nil.is(attrs['class']));
    attrs = attrs || {};
    attrs['class'] = 'form' + (stacked ? ' form-stacked' : ' form-inline');

    var html = [];
    for (var i = 0, rows_len = rows.length; i < rows_len; i++) {
      var row = rows[i];
      var cells_len = row.length;
      html.push('<div', attr({
        'class': ['form-group', 'form-group-' + i, 'nr-form-cells-' + cells_len]
      }), '>');
      for (var j = 0; j < cells_len; j++) {
        html.push(dom.div(row[j], {
          'class': ['form-cell', 'form-cell-' + j]
        }));
      }
      html.push('</div>');
    }
    return dom.div(html.join(''), attrs);
  }

  var data = this.data;
  var locale = this.locale;
  var value;
  var rows = this.rows.map(function(row) {
    return row.map(function(cell) {
      if (Str.is(cell)) {
        return cell;
      }
      else {
        value = data[cell.id];
        if (Nil.is(value)) { // normalizzo le non risposte al valore null
          value = null;
        }
        if (Obj.is(value)) {
          value = String(value);
        }
        return cell.to_html(value, locale, context);
      }
    });
  });
  return form(this.stacked, this.attrs, rows);
};

// attiva gli input contenuti nella form chiamando il loro metodo start(locale) se esiste.
Form.prototype.start = function() {
  var locale = this.locale;
  this.input_list.forEach(function(input) {
    if (Func.is(input.start)) {
      input.start(locale);
    }
  });
};

// mette il focus sul primo input che lo supporta
Form.prototype.focus = function() {
  var focused = false;
  any(this.input_list, function(input) {
    if (Func.is(input.focus) && !focused) {
      input.focus();
      return true;
    }
    return false;
  });
};

// attiva gli input e mette il focus
Form.prototype.start_and_focus = function() {
  this.start();
  this.focus();
};

// disattiva gli input
Form.prototype.stop = function() {
  this.input_list.forEach(function(input) {
    if (Func.is(input.stop)) {
      input.stop();
    }
  });
};

// una mappa id input -> valore input
// il parametro opzionale context serve a far arrivare eventuali informazioni
// di contesto che possono servire agli input
Form.prototype.value = function(context) {
  var locale = this.locale;
  var ret = {};
  var value;
  var focused = false;
  this.input_list.forEach(function(input) {
    value = input.value(locale, context);
    if (value.rule) {
      // metto il focus sul primo input che è andato male
      if (!focused && Func.is(input.focus)) {
        input.focus();
        focused = true;
      }
      ret = null;
    }
    else if (ret) {
      ret[input.id] = value.x;
    }
  });
  return ret;
};

Form.wrap_input = function(id, html, style, hint) {
  return [
    '<div' + attr({
      'class': 'input-wrapper',
      style: style
    }) + '>',
    html,
    '<div' + attr({
      "class": "error",
      id: id + "_error"
    }) + '></div>',
    '<div' + attr({
      "class": "hint",
      id: id + "_hint"
    }) + '>',
    hint || '',
    '</div>',
    '</div>'
  ].join('');
};

// Inputs
/*
var Textbox_Input_Schema = Union([Str_Schema, Num_Schema]);

Textbox_Input_Schema.of = function(x) {
  return Textbox_Input_Schema(Schema.of(x));
};

function Textbox_Input(id, schema, is_multiline, attrs, hint) {
  assert(Str.is(id));
  assert(Textbox_Input_Schema.is(schema));
  assert(Maybe(Bool).is(is_multiline));
  assert(Maybe(Obj).is(attrs));
  assert(Maybe(Str).is(hint));
  this.type = 'textbox';
  this.id = id;
  this.schema = schema;
  this.is_multiline = is_multiline;
  this.attrs = attrs;
  this.hint = hint;
  return freeze(this);
}

Textbox_Input.is = function(x) {
  return x instanceof Textbox_Input;
};

Textbox_Input.of = function(x) {
  assert(Obj.is(x));
  return new Textbox_Input(
    Str.of(x.id),
    Textbox_Input_Schema.of(x.schema),
    Maybe(Bool).of(x.is_multiline),
    Maybe(Obj).of(x.attrs),
    Maybe(Str).of(x.hint)
  );
};

Textbox_Input.prototype.to_html = function(value, locale) {
  assert(Maybe(JSON_Value).is(value));
  assert(Locale.is(locale));
  var id = this.id;
  var attrs = !Nil.is(this.attrs) ? copy(this.attrs) : {};
  attrs.id = id;
  var styles = split_margins(attrs.style);
  attrs.style = styles.other;
  if (this.is_multiline) {
    return Form.wrap_input(id, dom.textarea(value, attrs), styles.margins, this.hint);
  }
  attrs.value = JSON_Value.format(locale, this.schema, value);
  return Form.wrap_input(id, dom.textbox(attrs), styles.margins, this.hint);
};

Textbox_Input.prototype.focus = function() {
  $('#' + this.id).focus();
};

Textbox_Input.prototype.set_error = function(message) {
  $("#" + this.id + "_error").html(message);
};

Textbox_Input.prototype.value = function(locale) {
  assert(Locale.is(locale));
  var value = $('#' + this.id).val();
  var validation = this.schema.validate(value, locale);
  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
  return validation;
};

Form.add_input('textbox', Textbox_Input);
*/
/*
function Select_Input(id, options, schema, attrs, hint) {
  assert(Str.is(id));
  assert(List(Str_Option).is(options));
  assert(Str_Schema.is(schema));
  assert(Maybe(Obj).is(attrs));
  assert(Maybe(Str).is(hint));
  this.type = 'select';
  this.id = id;
  this.options = options;
  this.schema = schema;
  this.attrs = attrs;
  this.hint = hint;
  return freeze(this);
}

Select_Input.is = function(x) {
  return x instanceof Select_Input;
};

Select_Input.of = function(x) {
  assert(Obj.is(x));
  return new Select_Input(
    Str.of(x.id),
    List(Str_Option).of(x.options),
    Str_Schema.of(x.schema),
    Maybe(Obj).of(x.attrs),
    Maybe(Str).of(x.hint)
  );
};

Select_Input.prototype.to_html = function(value, locale) {
  assert(Maybe(JSON_Value).is(value));
  assert(Locale.is(locale));
  var id = this.id;
  var options = [EMPTY_OPTION].concat(this.options);
  var attrs = !Nil.is(this.attrs) ? copy(this.attrs) : {};
  attrs.id = id;
  var styles = split_margins(attrs.style);
  attrs.style = styles.other;
  return Form.wrap_input(id, dom.select_of_options(options, attrs, value), styles.margins, this.hint);
};

Select_Input.prototype.focus = function() {
  $('#' + this.id).focus();
};

Select_Input.prototype.set_error = function(message) {
  $("#" + this.id + "_error").html(message);
};

Select_Input.prototype.value = function(locale) {
  assert(Locale.is(locale));
  var value = $('#' + this.id).val();
  var validation = this.schema.validate(value, locale);
  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
  return validation;
};

Form.add_input('select', Select_Input);
*/
/*
function Date_Input(id, is_accurate, schema, attrs, hint) {
  assert(Str.is(id));
  assert(Maybe(Bool).is(is_accurate));
  assert(Date_Schema.is(schema));
  assert(Maybe(Obj).is(attrs));
  assert(Maybe(Str).is(hint));
  this.type = 'date';
  this.id = id;
  this.is_accurate = is_accurate;
  this.schema = schema;
  this.attrs = attrs;
  this.hint = hint;
  return freeze(this);
}



Date_Input.is = function(x) {
  return x instanceof Date_Input;
};

Date_Input.of = function(x) {
  assert(Obj.is(x));
  return new Date_Input(
    Str.of(x.id),
    Maybe(Bool).of(x.is_accurate),
    Date_Schema.of(x.schema),
    Maybe(Obj).of(x.attrs),
    Maybe(Str).of(x.hint)
  );
};

Date_Input.prototype.to_html = function(value, locale) {
  assert(Maybe(JSON_Value).is(value));
  assert(Locale.is(locale));
  var id = this.id;
  var order = this.is_accurate ?
    locale.locale_bundle().date.accurate_order :
    locale.locale_bundle().date.order;
  var attrs = !Nil.is(this.attrs) ? copy(this.attrs) : {};
  attrs.id = id;
  var styles = split_margins(attrs.style);
  attrs.style = styles.other;
  return Form.wrap_input(id, date(attrs, value, order), styles.margins, this.hint);
};

Date_Input.prototype.focus = function() {
  $('#' + this.id).children().get(0).focus();
};

Date_Input.prototype.set_error = function(message) {
  $("#" + this.id + "_error").html(message);
};

Date_Input.prototype.value = function(locale) {
  assert(Locale.is(locale));
  var id = this.id;
  var value = [
    $('#' + id + " .years").val(),
    $('#' + id + " .months").val(),
    $('#' + id + " .days").val()
  ];
  if (this.is_accurate) {
    value.push(
      $('#' + id + " .hours").val(),
      $('#' + id + " .minutes").val()
    );
  }
  var validation = this.schema.validate(value, locale);
  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
  return validation;
};

Form.add_input('date', Date_Input);
*/
/*
function Checkbox_Input(id, schema, attrs, hint) {
  assert(Str.is(id));
  assert(Bool_Schema.is(schema));
  assert(Maybe(Obj).is(attrs));
  assert(Maybe(Str).is(hint));
  this.type = 'checkbox';
  this.id = id;
  this.schema = schema;
  this.attrs = attrs;
  this.hint = hint;
  return freeze(this);
}

Checkbox_Input.is = function(x) {
  return x instanceof Checkbox_Input;
};

Checkbox_Input.of = function(x) {
  assert(Obj.is(x));
  return new Checkbox_Input(
    Str.of(x.id),
    Bool_Schema.of(x.schema),
    Maybe(Obj).of(x.attrs),
    Maybe(Str).of(x.hint)
  );
};

Checkbox_Input.prototype.to_html = function(value, locale) {
  assert(Maybe(JSON_Value).is(value));
  assert(Locale.is(locale));
  var id = this.id;
  var attrs = !Nil.is(this.attrs) ? copy(this.attrs) : {};
  attrs.id = id;
  attrs.checked = value;
  var styles = split_margins(attrs.style);
  attrs.style = styles.other;
  return Form.wrap_input(id, dom.checkbox(attrs), styles.margins, this.hint);
};

Checkbox_Input.prototype.focus = function() {
  $('#' + this.id).focus();
};

Checkbox_Input.prototype.set_error = function(message) {
  $("#" + this.id + "_error").html(message);
};

Checkbox_Input.prototype.value = function(locale) {
  assert(Locale.is(locale));
  var id = this.id;
  var checked = $('#' + id).is(':checked');
  var validation = this.schema.validate(checked, locale);
  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
  return validation;
};

Form.add_input('checkbox', Checkbox_Input);

function Radio_Input(id, options, schema, attrs, hint) {
  assert(Str.is(id));
  assert(List(Str_Option).is(options));
  assert(Str_Schema.is(schema));
  assert(Maybe(Obj).is(attrs));
  assert(Maybe(Str).is(hint));
  this.type = 'radio';
  this.id = id;
  this.options = options;
  this.schema = schema;
  this.attrs = attrs;
  this.hint = hint;
  return freeze(this);
}

Radio_Input.is = function(x) {
  return x instanceof Radio_Input;
};

Radio_Input.of = function(x) {
  assert(Obj.is(x));
  return new Radio_Input(
    Str.of(x.id),
    List(Str_Option).of(x.options),
    Str_Schema.of(x.schema),
    Maybe(Obj).of(x.attrs),
    Maybe(Str).of(x.hint)
  );
};

Radio_Input.prototype.to_html = function(value, locale) {
  assert(Maybe(JSON_Value).is(value));
  assert(Locale.is(locale));
  var id = this.id;
  var attrs = !Nil.is(this.attrs) ? copy(this.attrs) : {};
  attrs.id = id;
  var styles = split_margins(attrs.style);
  attrs.style = styles.other;
  return Form.wrap_input(id, radio_group(this.options, id, attrs, value), styles.margins, this.hint);
};

Radio_Input.prototype.focus = function() {
  $('#' + this.id + ' input[type=radio]').get(0).focus();
};

Radio_Input.prototype.set_error = function(message) {
  $("#" + this.id + "_error").html(message);
};

Radio_Input.prototype.value = function(locale) {
  assert(Locale.is(locale));
  var id = this.id;
  var value = $('#' + id + ' input[type=radio]:checked').val() || "";
  var validation = this.schema.validate(value, locale);
  this.set_error(validation.rule ? validation.rule.localize(locale) : '');
  return validation;
};

Form.add_input('radio', Radio_Input);
*/
function load_css(href) {
  var doc = document,
    head = doc.head || doc.getElementsByTagName("head")[0],
    link = doc.createElement('link');

  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = href;
  head.appendChild(link);
}

var dom = {};

function build_tag_factory(tag_name, can_have_content) {
  if (can_have_content) {
    return function(content, attrs) {
      return '<' + tag_name + attr(attrs || {}) + '>' + (content || '') + '</' + tag_name + '>';
    };
  }
  else {
    return function(attrs) {
      return '<' + tag_name + attr(attrs || {}) + '/>';
    };
  }
}

// build empty tags
'input'.split(' ').map(function(tagname) {
  dom[tagname] = build_tag_factory(tagname, false);
});
// build rest of tags
'a button div h2 h3 label li ol option select small table textarea ul'.split(' ').map(function(tagname) {
  dom[tagname] = build_tag_factory(tagname, true);
});

// inputs
function build_input_factory(type) {
  return function(attrs) {
    attrs = attrs || {};
    attrs.type = attrs.type || type; // altrimenti non riesco a costruire una input type="password"
    return dom.input(attrs);
  };
}

dom.textbox = build_input_factory('text');
dom.password = build_input_factory('password');
dom.checkbox = build_input_factory('checkbox');
dom.radio = build_input_factory('radio');

dom.select_of_options = function(options, attrs, selected_option_value) {
  var option_of_tuple = function(tuple) {
    return dom.option(tuple[1], {
      value: tuple[0],
      selected: selected_option_value === tuple[0]
    });
  };
  return dom.select(options.map(option_of_tuple).join(''), attrs);
};

dom.link_button = function(content, attrs) {
  attrs = attrs || {};
  attrs.href = attrs.href ? attrs.href : '#';
  return dom.a(content, attrs);
};

// Server api

var Http_Method = Enum(['get', 'post']);
var Http_Data_Type = Enum(['json']);
var Http_Params = Dict(Str, Func);

function Http(async, url, method, data_type, url_params, form_params) {
  assert(Bool.is(async));
  assert(Str.is(url));
  assert(Http_Method.is(method));
  assert(Http_Data_Type.is(data_type));
  assert(Maybe(Http_Params).is(url_params));
  assert(Maybe(Http_Params).is(form_params));

  this.async = async;
  this.url = url;
  this.method = method;
  this.data_type = data_type;
  this.url_params = url_params;
  this.form_params = form_params;
  return freeze(this);
}

Http.is = function(x) {
  return x instanceof Http;
};

Http.of = function(x) {
  assert(Obj.is(x));
  return new Http(
    Bool.of(x.async),
    Str.of(x.url),
    Http_Method.of(x.method),
    Http_Data_Type.of(x.data_type || 'json'), // default json
    Maybe(Http_Params).of(x.url_params),
    Maybe(Http_Params).of(x.form_params)
  );
};

Http.parse_response = function(response) {
  try {
    return response ?
      JSON.parse(response) :
      null;
  }
  catch (e) {
    return null;
  }
};

Http.checked_error = function(xhr, text_status, thrown_error) {
  var json = Http.parse_response(xhr.responseText);
  if (json && !Nil.is(json.error)) {
    return Err.of({
      name: json.error,
      response_error: json
    });
  }
  return Http.unexpected_error(xhr, text_status, thrown_error);
};

Http.unexpected_error = function(xhr, text_status, thrown_error) {
  if (text_status === "timeout") {
    xhr.abort();
    return Err.of({
      name: "timeout",
      message: "timeout"
    });
  }
  return Err.of({
    name: thrown_error
  });
};

Http.to_error = function(args, xhr, text_status, thrown_error) {
  var err = text_status === "error" && xhr ?
    Http.checked_error(xhr, text_status, thrown_error) :
    Http.unexpected_error(xhr, text_status, thrown_error);
  err.request = this;
  err.args = args;
  err.xhr = xhr;
  return err;
};

Http.prototype.to_func = function() {
  var self = this;
  return function(args, callback) {
    assert(Obj.is(args));
    assert(Maybe(Func).is(callback));

    var url_args = {};
    var form_args = {};
    var param;
    var arg;

    for (param in self.url_params) {
      arg = args[param];
      // controllo il tipo dei parametri
      assert(self.url_params[param].is(arg));
      // converto gli argomenti in stringa
      /*
          arg = typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
          // i parametri nell'url vanno encondati
          url_args[encodeURIComponent(param)] = encodeURIComponent(arg);
      */
      if (arg) {
        arg = typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
        // i parametri nell'url vanno encondati
        url_args[encodeURIComponent(param)] = encodeURIComponent(arg);
      }
      else {
        url_args[encodeURIComponent(param)] = "";
      }
    }
    for (param in self.form_params) {
      arg = args[param];
      // controllo il tipo delle form
      assert(self.form_params[param].is(arg));
      // converto gli argomenti in stringa
      arg = typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
      form_args[param] = arg;
    }

    // fix IE bug: se method = "post" e non c'è nessun parametro nella form, IE manda una chiamata in GET
    if (self.method === 'post' && Obj.is_empty(form_args)) {
      form_args["__noemptybody__"] = "";
    }

    // converto la configurazione dell'api in una configurazione del metodo ajax() di jQuery
    var url = template(self.url)(url_args);
    var config = {
      async: self.async,
      cache: false,
      type: self.method,
      dataType: self.data_type,
      url: url,
      data: form_args
    };

    var request = $.ajax(config);
    if (callback) {
      request.then(function(response) {
        callback(null, response);
      }, function(xhr, text_status, thrown_error) {
        callback(Http.to_error(args, xhr, text_status, thrown_error));
      });
      return null;
    }
    else {
      return request.then(function(response) {
        return response;
      }, function(xhr, text_status, thrown_error) {
        return Http.to_error(args, xhr, text_status, thrown_error);
      }).promise();
    }

  };
};

function http(config) {
  return Http.of(config).to_func();
}

//
// single page application
//

function Unexpected_Error_State(err) {
  assert(err instanceof Error);
  this.name = 'unexpected_error';
  this.err = err;
  return freeze(this);
}

Unexpected_Error_State.prototype.to_widget = function(app, callback) {
  var html = [
    '<div id="unexpected_error" class="alert error">',
    '<h1>Unexpected error :-(</h1>',
    '<pre>', JSON.stringify(this.err, null, 4), '</pre>',
    '</div>'
  ].join('');
  callback(new Widget(html));
};

function Disabled_Cookies_State() {
  this.name = 'disabled_cookies';
  return freeze(this);
}

Disabled_Cookies_State.prototype.to_widget = function(app, callback) {
  var html = [
    '<div id="disabled_cookies" class="alert error">',
    '<h1>Cookies not enabled</h1>',
    '<p>This web application requires enabled cookies.\nPlease make sure cookies are enabled in your browser and try again.</pre>',
    '</div>'
  ].join('');
  callback(new Widget(html));
};

var SPA = {
  protect_method: function(f) {
    return function(args, callback) {
      $('body').addClass('wait');
      f(args, function(err, result) {
        $('body').removeClass('wait');
        callback(err, result);
      });
    };
  },
  extend: function(ctor, options) {

    assert(Func.is(ctor));
    assert(Maybe(Obj).is(options));

    options = options || {};
    options.view_id = options.view_id || 'view';
    options.scroll_selector = options.scroll_selector || 'html, body';
    options.on_start = options.on_start || noop;
    options.on_state_load = options.on_state_load || noop;

    // to_html()
    ctor.prototype.to_html = ctor.prototype.to_html || function() {
      var html = '<div id="' + options.view_id + '"></div>';
      if ($('#shield').length === 0) {
        html += '<div id="shield"></div>';
      }
      if ($('#ajax').length === 0) {
        html += '<div id="ajax"><div></div></div>';
      }
      return html;
    };

    // start()
    assert(Nil.is(ctor.prototype.start));
    ctor.prototype.start = function() {
      options.on_start.call(this);
      if (options.cookies && !is_cookies_enabled()) {
        this.io(new Disabled_Cookies_State());
      }
      else {
        this.io(this.state);
      }
    };

    // stop()
    assert(Nil.is(ctor.prototype.stop));
    ctor.prototype.stop = function() {
      if (this.widget) {
        this.widget.stop();
      }
    };

    // render_to($el)
    assert(Nil.is(ctor.prototype.render_to));
    ctor.prototype.render_to = function($el) {
      $(this.to_html()).appendTo($el);
      this.start();
      return this;
    };

    // io()
    assert(Nil.is(ctor.prototype.io));
    ctor.prototype.io = function(state) {

      assert(Obj.is(state));
      assert(Func.is(state.to_widget));

      const app = this;

      function mountWidget(widget) {
        app.widget = widget;
        $('#' + options.view_id).html(widget.to_html());
        widget.start();
      }

      this.stop();
      this.state = state;
      state.to_widget(this, (widget) => {

        if (widget instanceof Widget) {
          mountWidget(widget);
        }
        else {
          //mountComponent(widget);
        }

        // a volte non mi interessa far scrollare la pagina in cima
        // ad esempio se viene fatto un update frequente in una parte della pagina
        // che so essere molto in fondo e non voglio che l'utente venga
        // disorientato da un continuo scrolling della pagina
        if (!state.do_not_scroll) {
          $(options.scroll_selector).animate({
            scrollTop: 0
          }, 'fast');
        }

        options.on_state_load.call(app);
      });

    };

    // se c'è baco non posso fare altro che mostrare lo stack trace
    assert(Nil.is(ctor.prototype.go_unexpected_err));
    ctor.prototype.go_unexpected_err = function(err) {
      this.io(new Unexpected_Error_State(err));
    };

    return ctor;

  }

};

module.exports = {

  assert: assert,

  Nil: Nil,

  Str: Str,
  //String: Str,
  Num: Num,
  //Number: Num,
  Int: Int,
  Bool: Bool,
  //Boolean: Bool,
  Func: Func,
  //Function: Func,
  Obj: Obj,
  //Object: Obj,
  Arr: Arr,
  //Array: Arr,
  Err: Err,
  //Error: Err,
  Enum: Enum,
  //enums: Enum,
  Subtype: Subtype,
  //subtype: Subtype,
  Union: Union,
  //union: Union,
  Maybe: Maybe,
  //maybe: Maybe,
  List: List,
  //list: List,
  Tuple: Tuple,
  //tuple: Tuple,
  Dict: Dict,
  //dict: Dict,
  Interface: Interface,

  // common types
  Amount: Amount,
  Color: Color,
  Country: Country,
  Currency: Currency,
  Datetime: Datetime,
  Email: Email,
  JSON_Value: JSON_Value,
  Language: Language,
  Locale_Iso: Locale_Iso,
  Locale: Locale,
  Natural: Natural,
  Positive: Positive,
  URL: URL,
  UUID: UUID,
  Markdown: Markdown,
  Str_Option: Str_Option,

  // tool di sviluppo
  uuid: uuid,
  mixin: mixin,
  merge: merge,
  copy: copy,
  log: log,
  all: all,
  any: any,
  keys: keys,
  values: values,
  freeze: freeze,
  prop: prop,
  by: by,
  by_description: by_description,
  noop: noop,
  map_obj: map_obj,
  find: find,
  remove: remove,
  move: move,
  compact: compact,
  Emitter: Emitter,
  template: template,
  mustache: mustache,
  to_obj: to_obj,
  to_arr: to_arr,
  http: http,
  fold: fold,
  drop: drop,
  take: take,
  trim_left: trim_left,
  trim_right: trim_right,
  pad_left: pad_left,
  pad_right: pad_right,
  pad_center: pad_center,
  repeat: repeat,
  to_querystring: to_querystring,
  parse_querystring: parse_querystring,
  truncate: truncate,
  index_of: index_of,
  unique: unique,
  flatten: flatten,
  range: range,
  to_url: to_url,
  pluralize: pluralize,
  starts_with: starts_with,
  is_integer: is_integer,
  is_uuid: is_uuid,
  is_email: is_email,
  is_digits: is_digits,
  is_url: is_url,
  is_https_url: is_https_url,
  is_color: is_color,
  is_positive: is_positive,
  is_not_negative: is_not_negative,
  is_cookies_enabled: is_cookies_enabled,
  is_even: is_even,

  // input
  Str_Format: Str_Format,
  Str_Schema: Str_Schema,
  Num_Schema: Num_Schema,
  Bool_Schema: Bool_Schema,
  Arr_Schema: Arr_Schema,
  Date_Schema: Date_Schema,
  Schema: Schema,
  Validation: Validation,
  Rule: Rule,
  Validation_Monad: Validation_Monad,
  // html
  dom: dom,
  table: table,
  escape_html: escape_html,
  abbr: abbr,
  Widget: Widget,
  Widget_Interface: Widget_Interface,
  Form: Form,
  //Textbox_Input: Textbox_Input,
  EMPTY_OPTION: EMPTY_OPTION,
  radio_group: radio_group,
  micromd: micromd,
  attr2: attr2,
  attr: attr,
  css: css,
  split_margins: split_margins,
  Message: Message,
  load_css: load_css,

  SPA: SPA,
  Number_Format: Number_Format,
  date: date
};



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/jsdk.js
 **/